import styled, { css } from "styled-components";
import BorderedContainer from "../../../../../../components/BorderedContainer";
import Button from "../../../../../../components/Button";
import { Colors } from "../../../../../../constants";

export const InfoTitle = styled.div`
  color: var(--luft-primary);
  font-weight: 500;
  font-size: 16px;
  line-height: 18px;
  font-family: 'Work Sans';
  margin-bottom: 24px;
`;

export const StyledBorderedContainer = styled(BorderedContainer)`
  margin-bottom: 16px;

  border: ${(props) => props.emphasis && '4px solid rgba(16, 119, 185, 0.3)'};

  &:last-child {
    margin-top: 32px;
  }
`;

export const RecipientsNumberContainer = styled.div`
  margin-top: 2px;
  display: flex;
`;

export const RecipientsNumber = styled.div`
  min-width: 96.5px;
  height: 52px;

  display: flex;
  justify-content: center;
  align-items: center;
  
  color: #0B79D0;
  font-size: 36px;
  line-height: 36px;

  border-radius: 4px;
  background: rgba(16, 119, 185, 0.08);
`;


export const RecipientsNumberDescription = styled.span`
  color: #999999;
  margin-left: 8px;
`;

export const RecipientsNumberDescriptionUnavailable = styled.span`
  padding: 8px;
  color: ${Colors.SECONDARY_DARK_GREY};
  background-color: rgba(16, 119, 185, 0.08);
  border-radius: 4px;
`;

export const StyledButton = styled(Button)`
  width: 100%;
  margin-top: 16px;

  &:disabled {
    cursor: not-allowed;
    color: rgba(0, 0, 0, 0.26);
    background-color: rgba(0, 0, 0, 0.12);
    &:hover {
      opacity: 0.5;
    }
  }
`;

export const RecipientsTrackingContainer = styled.div`
  display: flex;
`;

export const TooltipParagraph = styled.p`
  font-size: 14px;
  font-family: var(--luft-fonts);
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Col = styled.div`
  ${({ xs12 }) =>
    xs12 &&
    css`
      flex: 0 0 auto;
      width: 100%;
    `}
  ${({ sm6 }) =>
    sm6 &&
    css`
      @media (min-width: 576px) {
        flex: 0 0 auto;
        width: 50%;
      }
    `}
  ${({ md12 }) =>
    md12 &&
    css`
      @media (min-width: 768px) {
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
        max-width: 100%;
      }
    `}
`;

export const StyledTitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 20px;
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: var(--luft-primary);
`;

export const StrongText = styled.span`
  color: #000;
  font-weight: bold;
`;

export const SecondaryTitle = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: ${Colors.SUCCESS}
`;

export const ShippingCompanyDataContainer = styled.div`
  display: flex;
  padding: 0px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

export const ShippingCompanyLeftData = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

export const ShippingCompanyRightData = styled.div`
  display: flex;
  padding: 4px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
`;

export const ShippingCompanyName = styled.div`
  color: #000;
`;

export const ShippingCompanyCnpj = styled.div`
  font-size: 14px;
`;

export const ShippingCompanyIcon = styled.img`
  width: 24px;
  height: 24px;
`;
